import React from 'react';
import { createPortal } from 'react-dom';
import { Popup } from '@/components/Popup';
import styles from './styles.module.scss';

export interface ModalFormProps {
  /** Modal title */
  title: string;
  /** Close handler */
  onClose: () => void;
  /** Form submit handler */
  onSubmit: (e: React.FormEvent) => void;
  /** Submit button label */
  submitLabel?: string;
  /** Cancel button label */
  cancelLabel?: string;
  /** Loading state */
  isSubmitting?: boolean;
  /** Error message */
  error?: string | null;
  /** Info message (shows above error) */
  infoMessage?: string;
  /** Form content */
  children: React.ReactNode;
  /** Additional className for popup */
  className?: string;
}

/**
 * Base modal form component.
 * Uses Popup component with card styling for consistent appearance.
 * Used as base for TournamentHolderCoefficientForm, PredictionForm, etc.
 */
export const ModalForm: React.FC<ModalFormProps> = ({
  title,
  onClose,
  onSubmit,
  submitLabel = 'Сохранить',
  cancelLabel = 'Отмена',
  isSubmitting = false,
  error,
  infoMessage,
  children,
  className,
}) => {
  return (
    <>
    {isSubmitting && createPortal(
      <div className="spinner-overlay"><div className="spinner" /></div>,
      document.body
    )}
    <Popup open={true} onClose={onClose} popupClass={className}>
      <div className="d-flex flex-column g-20">
        {/* Header */}
        <div className="d-flex flex-column g-10">
          <h2 className={styles.title}>{title}</h2>
        </div>

        {/* Form */}
        <div className="d-flex flex-column g-16">
          <form onSubmit={onSubmit} className={styles.form}>
            {children}

            {/* Info message */}
            {infoMessage && (
              <div className={styles.infoBox}>
                {infoMessage}
              </div>
            )}

            {/* Error */}
            {error && (
              <div className={styles.errorBox}>
                {error}
              </div>
            )}

            {/* Buttons */}
            <div className={styles.buttons}>
              <button
                type="button"
                onClick={onClose}
                className="btn btn--outlined"
                disabled={isSubmitting}
              >
                {cancelLabel}
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="btn"
              >
                {submitLabel}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Popup>
    </>
  );
};

export default ModalForm;
